import { useState } from 'react';
import AppLayout from '@amzn/awsui-components-react/polaris/app-layout';

import NavigationBreadcrumbs from "../../common/navigation/NavigationBreadcrumbs";
import SideNavigationMenu from '../../common/navigation/SideNavigationMenu';
import Paths from "common/paths/paths";
import { useFlashBarItems } from 'common/UseFlashBarItems/useFlashBarItems';
import { Flashbar, SpaceBetween } from "@amzn/awsui-components-react";
import { useOrderEdit } from './useOrderEdit';
import { SinglePageDetailsContainer } from 'components/OrderDetailsContent/SinglePage/SinglePageDetailsContainer';
import { NonCancelableEventHandler } from "@amzn/awsui-components-react/polaris/internal/events";
import { SplitPanel } from "@amzn/awsui-components-react/polaris";
import { useParams } from "react-router-dom";
import { AuditTrailsTable } from "../../components/AuditTrails/AuditTrailsTable";

interface OrderDetailsSingleViewPageProps {
  isExternalView?: boolean
}

const OrderDetailsSingleViewPage = (props: OrderDetailsSingleViewPageProps) => {
  const flashBarItemsHook = useFlashBarItems();
  const { items, actions } = useOrderEdit(flashBarItemsHook.actions, props.isExternalView);
  const [navigationOpen, setNavigationOpen] = useState(false);
  const [showSplitPanel, setSplitPanel] = useState(false);

  const breadcrumbs = {
    items:
      [
        { text: Paths.Admin.name, href: Paths.Admin.url },
        { text: Paths.manageOrders.name, href: Paths.manageOrders.url },
        { text: items.orderReference, href: "#" }
      ]
  }

  // Retrieve Order Id from URL params
  const { id } = useParams();

  const onSplitPanelToggle: NonCancelableEventHandler = () => {
      setSplitPanel(false);
  };

  const showAuditsPanel = () => {
      setSplitPanel(true);
  };

  return (
    <AppLayout
      maxContentWidth={2300}
      stickyNotifications
      content={
        <SpaceBetween direction="vertical" size="m">
          <SinglePageDetailsContainer
            useOrderEditItems={items}
            useOrderEditActions={actions}
            useFlashBarItemsActions={flashBarItemsHook.actions}
            showAuditsPanel={showAuditsPanel}
          />
        </SpaceBetween>
      }
      contentType="default"
      breadcrumbs={!props.isExternalView && <NavigationBreadcrumbs items={breadcrumbs.items} />}
      navigation={<SideNavigationMenu />}
      navigationOpen={navigationOpen}
      onNavigationChange={(event: any) => setNavigationOpen(event.detail.open)}
      navigationHide={props.isExternalView}
      notifications={<Flashbar items={flashBarItemsHook.flashBarItems} stackItems data-testid="notifications-flashbar" />}
      toolsHide={true}
      splitPanelOpen={showSplitPanel}
      onSplitPanelToggle={onSplitPanelToggle}
      splitPanel={
          <SplitPanel
              closeBehavior="hide"
              data-testid="audit-trail-split-panel"
              header={id}
              hidePreferencesButton={true}
          >
            <AuditTrailsTable/>
          </SplitPanel>
      }
    />
  );
}

export default OrderDetailsSingleViewPage;
